import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ffd49f0"
import script from "./taxRegime.js?vue&type=script&lang=js&external"
export * from "./taxRegime.js?vue&type=script&lang=js&external"
import style0 from "./taxRegime.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports